export const GRID_LAYOUT_DRAG_HANDLE_PROPS = {
  'data-grid-layout-drag-handle': 'true',
} as const;

export const GRID_LAYOUT_DRAG_HANDLE_SELECTOR = '[data-grid-layout-drag-handle]';
